import type { LocationQuery } from 'vue-router'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

/**
 * Returns a function building the query params that keep the guest context
 * when an Intercom conversation is opened.
 * `bm_user_id` is only added when it isn't already in the current URL query.
 */
export const useIntercomGuestQuery = () => {
  const { isUserGuest, user } = useUserStore()

  return (currentQuery: LocationQuery): Record<string, string> => {
    if (!isUserGuest.value) return {}

    return {
      is_user_guest: 'true',
      ...(!currentQuery.bm_user_id && { bm_user_id: user.value.bmUserId }),
    }
  }
}
